import React from "react";
import cn from "classnames";

const CardContainerDetail = ({ title, children, variant }) => {
  return (
    <div
      className={cn(
        `border-start rounded-2 border-3 mb-2`,
        variant ? `border-${variant}` : `border-primary`
      )}
      style={{ backgroundColor: "rgba(59, 59, 59, 0.1)" }}
    >
      <div className="px-3 py-2 fsz-12 fw-bold">{title}</div>
      <div className="px-3 fsz-12 bg-white ">{children}</div>
    </div>
  );
};

export default CardContainerDetail;
